import React, { useState, useEffect } from "react";
import {
  Breadcrumbs,
  Button,
  Container,
  Grid,
  Typography,
  Box,
  Menu,
} from "@mui/material";
import ColorPalette from "../VideoGenSettings/ColorPalette";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";
import { button_bg_color_for_New_Project } from "../../../../constants/colors";
import { HexColorPicker } from "react-colorful";
import './Background.css'

const color = [
  { id: 2, name: "Coral", color_code: "#D98E8E" },
  { id: 3, name: "Purple", color_code: "#9370DB" },
  { id: 4, name: "Red", color_code: "#DC143C" },
  { id: 5, name: "", color_code: "#FFDAB9" },
  { id: 6, name: "", color_code: "#98FB98" },
];

const Background = (props) => {
  const { selectedBgColorForHeygenVideo, setSeletedBgColorForHeygenVideo } = useWorkspace();
  const theme = localStorage.getItem("theme");
  const [selectedBackground, setSelectedBackground] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("Solid color");
  const [selectedCategoryColorData, setSelectedCategoryColorData] = useState(color);
  const [selectedCategoryImageData, setSelectedCategoryImageData] = useState(null);
  const [selectedCategoryVideoData, setSelectedCategoryVideoData] = useState(null);
  const [showcolorpalette, setShowcolorpalette] = useState(false);
  const [selectedcolor, setSelectedColor] = useState(selectedBgColorForHeygenVideo);
  const [selectedColorForCaptionText, setSelectedColorForCaptionText] =
    useState("#FFFFFF");
  const [selectedcolorid, setSelectedColorId] = useState();
  const [tempColor, setTempColor] = useState(selectedcolor);
  const [tempColorRgbCode, setTempColorRgbCode] = useState({ r: 0, g: 0, b: 0 });

  const handleCategorySelect = (categories) => {
    setSelectedCategory(categories);
  };


    useEffect(()=>{
       if(tempColor != "#FFFFFF" || "#ffffff"){
          setTempColorRgbCode(hexToRgb(tempColor))
        }
    },[tempColor])

  const rgbaToHex = ({ r, g, b }) => {
    const red = r.toString(16).padStart(2, "0");
    const green = g.toString(16).padStart(2, "0");
    const blue = b.toString(16).padStart(2, "0");
    return `#${red}${green}${blue}`;
  };

  const hexToRgb = (hex) => {
    hex = hex?.replace(/^#/, "");

    if (hex?.length === 3) {
      hex = hex?.split("").map((char) => char + char).join("");
    }
    const r = parseInt(hex?.substring(0, 2), 16);
    const g = parseInt(hex?.substring(2, 4), 16);
    const b = parseInt(hex?.substring(4, 6), 16);
    return { r, g, b };
  };

  useEffect(() => {
    if (selectedBgColorForHeygenVideo != "#FFFFFF" || "#ffffff") {
      setSelectedColor(selectedBgColorForHeygenVideo)
    }
  }, [])

    const handleSave = () => {
    setSelectedColor(tempColor);
  };

  if (props.color && props.color.length > 0)
    setSeletedBgColorForHeygenVideo(props.color);

  const handleBackgroundSelect = (colorObj) => {
    setSelectedColorId(colorObj?.id);
    setSeletedBgColorForHeygenVideo(colorObj?.color_code);
    // Only update timeline items if the props are provided (from VideoGenerate.jsx)
    if (props.timelineItems && typeof props.timelineItems === 'function' && props.activeTimelineItem !== undefined) {
      props.timelineItems((prevItems) => {
        const items = [...prevItems];

        items[props.activeTimelineItem] = {
          ...items[props.activeTimelineItem],
          background: colorObj?.color_code || selectedBgColorForHeygenVideo,
        };

        return items;
      });
    }
  };


  const renderBackgrounds = () => {
    if (
      !selectedCategory ||
      selectedCategory == "Image" ||
      selectedCategory == "Video"
    )
      return null;
    return (
      <>
        <Grid container spacing={2}>
          {/* Custom Color Picker */}
          <Grid item xs={4}>
            <Box
              onClick={(event) => {
                handleBackgroundSelect({ id: 0, name: "", color_code: "" });
              }}
              sx={{
                cursor: "pointer",
                border: selectedBackground?.id === 0 ? "5px solid orange" : "none",
                backgroundColor: `${selectedcolor}`,
                color: "#17182C",
                height: "140px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "end",
                justifyContent: "space-between",
                padding: "16px",
                "&:hover": {
                  outline: "2px solid rgba(202, 196, 208, 0.60)",
                  padding: "16px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: "rgba(202, 196, 208, 0.60)",
                    border: "1px solid rgba(0, 0, 0, 0.20)",
                    padding: "8px",
                    borderRadius: "8px",
                  }}
                >
                  {/* <ColorLensOutlinedIcon /> */}
                  {/* <Box ml={1}>Choose custom color</Box> */}
                </Box>
              </Box>
              <Box sx={{ fontWeight: 600 }}>{selectedcolor}</Box>
            </Box>
          </Grid>

          {/* Color Swatches */}
          {selectedCategoryColorData?.map((background) => (
            <Grid item xs={4} key={background.id}>
              <Box
                sx={{
                  cursor: "pointer",
                  border:
                    selectedcolorid === background.id ? "2px solid #CAC4D0" : "none",
                  backgroundColor: `${background?.color_code}`,
                  color: "#17182C",
                  height: "140px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "space-between",
                  padding: "16px",
                  "&:hover": {
                    outline: "2px solid rgba(202, 196, 208, 0.60)",
                    padding: "16px",
                  },
                }}
                onClick={() => handleBackgroundSelect(background)}
              >
                <Box sx={{ fontWeight: 600 }}>
                  {background?.name === "white" ? "Custom" : background?.name}
                </Box>
                <Box sx={{ fontWeight: 600 }}>{background?.color_code}</Box>
              </Box>
            </Grid>
          ))}
        </Grid>

      </>
    );
  };


  return (
    <Box
      sx={{
        color: theme === "dark" ? "white" : "black",
        // border: "1px solid green",
        padding: "0px, 0px",
        // maxHeight: "100%",
        margin:"0px 0px"
      }}
    >
      <div>
        <Typography
          variant="h6"
          gutterBottom
          style={{
            fontSize: "20px",
            fontWeight: "500",
            height: "20px",
            marginBottom: "20px",
            // border: "1px solid red"
          }}
        >
          Select Video Background
        </Typography>
      </div>
      <Box sx={{ border: "",width:"100%", display: "flex", flexDirection: "row", columnGap: "32px", justifyContent:"space-between" }}>
        <Box sx={{  border: ""}}>
          <Typography
            variant="h6"
            gutterBottom
            style={{
              fontSize: "16px",
              fontWeight: "500",
              //   width: "193px",
              height: "20px",
              marginBottom: "20px",

            }}
          >
            Choose custom colors
          </Typography>
          <Box>
           <Box sx={{ bgcolor: "#2C2C2C", height:"327px", width:"258px", p:2 }}>
                <Box className="custom-layout example">
                  <HexColorPicker color={selectedcolor} onChange={setSelectedColor} />

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      margin:"0px 0px",
                      padding:"0px 0px"
                    }}
                  >
                    <Box>
                      <Box
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: 500,
                        }}
                      >
                        HEX
                      </Box>
                      <Button
                        sx={{
                          backgroundColor: "#373E6D",
                          color: theme === "dark" ? "white" : "black",
                          "&:hover": {
                            backgroundColor: "#373E6D",
                          },
                          padding: "4px 8px",
                          minWidth: "43px",
                          mxnWidth: "43px",
                          minHeight: "20px",
                        }}
                      >
                        {selectedcolor}
                      </Button>
                    </Box>
                    <Box>
                      <Box sx={{ display: "flex", flexDirection: "row", gap: "2px" }}>
                        {["r", "g", "b"].map((key, index) => (
                          <Box key={key}>
                            <Box
                              sx={{
                                fontFamily: "Inter",
                                fontSize: "12px",
                                fontStyle: "normal",
                                fontWeight: 500,
                              }}
                            >
                              {key.toUpperCase()}
                            </Box>
                            <Button
                              sx={{
                                backgroundColor: "#373E6D",
                                color: theme === "dark" ? "white" : "black",
                                "&:hover": {
                                  backgroundColor: "#373E6D",
                                },
                                padding: "4px 8px",
                                minHeight: "20px",
                                minWidth: "30px",
                                borderRadius:
                                  index === 0
                                    ? "4px 0px 0px 4px"
                                    : index === 2
                                      ? "0px 4px 4px 0px"
                                      : "0px",
                              }}
                            >
                              {tempColorRgbCode[key]}
                            </Button>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1,
                      mt: 2,
                    }}
                  >
                  </Box>
                </Box>
            </Box> 
          </Box>
        </Box>
        <Box sx={{ width:"100%", border: ""}}>
          <Typography
            variant="h6"
            gutterBottom
            style={{
              fontSize: "16px",
              fontWeight: "500",
              height: "20px",
              marginBottom: "20px",
            }}
          >
            Suggested Colors for Background
          </Typography>
          <Box mt={2}>
            <Box sx={{p:2, backgroundColor:"#2C2C2C"}}>
            {renderBackgrounds()}
            </Box>
            </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Background